import { SaleInstalment } from '../api/SalesAPI';

function sortInstalments(instalments: SaleInstalment[]): SaleInstalment[] {
  return [...instalments].sort((a, b) => {
    const da = a.dueDate ?? '\uffff';
    const db = b.dueDate ?? '\uffff';
    if (da !== db) {
      return da.localeCompare(db);
    }
    return (a.id ?? 0) - (b.id ?? 0);
  });
}

/**
 * Whether paid-related fields differ between two instalment lists (order-agnostic; matches backend sort).
 */
export function instalmentPaidFieldsChanged(
  before: SaleInstalment[] | null | undefined,
  after: SaleInstalment[] | null | undefined
): boolean {
  const b = before ?? [];
  const a = after ?? [];
  if (b.length === 0 && a.length === 0) {
    return false;
  }
  if (b.length !== a.length) {
    return true;
  }
  const sb = sortInstalments(b);
  const sa = sortInstalments(a);
  for (let i = 0; i < sb.length; i++) {
    if (!!sb[i].isPaid !== !!sa[i].isPaid) {
      return true;
    }
    const pdBefore = sb[i].paidDate ?? '';
    const pdAfter = sa[i].paidDate ?? '';
    if (pdBefore !== pdAfter) {
      return true;
    }
  }
  return false;
}
